import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import CustomInputText from "../../components/forms/CustomInputText";
import CustomCheckbox from "../../components/forms/CustomCheckbox";
import CustomDropdown from "../../components/forms/CustomDropdown";
import { studentDocumentsApi } from "../../services/studentDocuments/studentDocumentsApi";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";
import { Formik } from "formik";
import * as Yup from "yup";

interface StudentCertificateDialogProps {
  visible: boolean;
  onHide: () => void;
  onGenerate: (values: CertificateFormValues) => void;
  document: any;
}

interface CertificateFormValues {
  documentNumber: string;
  documentNote: string;
  isDraft: boolean;
  documentTypeAttributeId: number | null;
  academicYearId: number | null;
  isEnrolled: boolean;
}

const validationSchema = Yup.object().shape({
  documentNumber: Yup.string().required("Полето е задължително"),
});

const initialValues: CertificateFormValues = {
  documentNumber: "",
  documentNote: "",
  isDraft: false,
  documentTypeAttributeId: null,
  academicYearId: null,
  isEnrolled: false,
};

const StudentCertificateDialog: React.FC<StudentCertificateDialogProps> = ({
  visible,
  onHide,
  onGenerate,
  document,
}) => {
  const { data: documentTypeAttributes } = studentDocumentsApi.useGetDocumentTypeAttributesQuery(5);
  const { data: academicYears } = academicYearsApi.useGetAcademicYearsQuery();
  const [loading, setLoading] = useState(false);

  const handleGenerate = async (values: CertificateFormValues) => {
    setLoading(true);
    try {
      await onGenerate(values);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={document ? document : initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleGenerate(values);
      }}
      enableReinitialize
    >
      {({ handleSubmit }) => (
        <Dialog
          header="Генериране на ново уверение"
          visible={visible}
          style={{ width: "450px" }}
          modal
          footer={
            <>
              <Button label="Отказ" icon="pi pi-times" outlined onClick={onHide} disabled={loading} />
              <Button label="Генериране" icon="pi pi-check" onClick={() => handleSubmit()} loading={loading} />
            </>
          }
          onHide={onHide}
        >
          <div className="flex flex-column gap-3">
            <CustomDropdown
              id="documentTypeAttributeId"
              options={documentTypeAttributes?.data ?? []}
              optionLabel="attributeDescription"
              optionValue="documentTypeAttributeId"
              placeholder="Изберете тип на уверението"
              label="Тип на уверението"
              showClear
            />
            <CustomInputText id="documentNumber" label="Номер на документа" required />
            <CustomInputText id="documentNote" label="Бележка" type="multiline" />
            <CustomDropdown
              id="academicYearId"
              options={academicYears?.data ?? []}
              optionLabel="name"
              optionValue="academicYearId"
              placeholder="Изберете академична година"
              label="Академична година"
              showClear
            />
            <CustomCheckbox id="isEnrolled" label="е записан/а (ако не е отбелязано - е бил/а записан/а)" />
            <CustomCheckbox id="isDraft" label="Чернова" />
          </div>
        </Dialog>
      )}
    </Formik>
  );
};

export default StudentCertificateDialog;
